import { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';

interface SectionProps extends PropsWithChildren {
  label: string;
  description?: string;
  infoButtonLabel?: string;
  flexChildren?: boolean;
  gap?: number;
  titleFontSize?: number;
}

const OnboardingSection = ({
  children,
  label,
  description,
  infoButtonLabel,
  gap = 15,
  titleFontSize = 22
}: SectionProps) => {
  const colors = useColor();

  return (
    <View style={{ flexDirection: 'column', gap: gap }}>
      <View style={styles.titleContainer}>
        <Text style={{ color: colors.titleText, fontSize: titleFontSize }} fontWeight="700">
          {label}
        </Text>
        {infoButtonLabel && (
          <InfoButton title={label} type="modal" {...(infoButtonLabel !== label && { message: infoButtonLabel })} />
        )}
      </View>

      {description && <Text style={{ color: colors.titleText }}>{description}</Text>}

      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    gap: 5,
    alignItems: 'center',
    paddingEnd: 32
  }
});

export default OnboardingSection;
